import { parsePosixLocale } from '~src/services/locale';
import { ManagerAttrs, UserCore, UserSettingsAttrs } from './user.interface';

export interface TimezonesI {
  [key: string]: string;
}

export interface ContentLocalesI {
  [key: string]: string;
}

export enum SystemLocales {
  DeDe = 'de_DE',
  EnUs = 'en_US',
}

export type DateFormats = Record<SystemLocales, string>;
export const getDateFormat = (locale: SystemLocales): string => {
  const formats: DateFormats = {
    [SystemLocales.DeDe]: 'DD.MM.YYYY',
    [SystemLocales.EnUs]: 'MM/DD/YYYY',
  };
  return formats[locale] || 'YYYY-MM-DD';
};

export const systemLocales = Object.values(SystemLocales);

export function localeToLanguage(locale: string): string {
  return parsePosixLocale(locale).language;
}

export type SystemLocalesI = { [key in SystemLocales]: string };

export interface SessionUserI extends UserCore {
  created_at: string;
  deleted_at: string | null;
  external: boolean;
  framework: boolean;
  imageUrl: string | null;
  isManager: boolean;
  manager_attributes: ManagerAttrs;
  setting_attributes: UserSettingsAttrs;
  updated_at: string;
  userPermissions: UserPermissions[];
  uuid: string;
  firstname: string;
}

export enum UserPermissions {
  ManageMe = 'manage_me',
  ManageCompany = 'manage_company',
  ManageUsers = 'manage_users',
}
